import { useTranslation } from 'react-i18next';
import { Domain as DomainEnum } from '@tiendanube/common/src/enums';
import { Card, Text } from '@tiendanube/components';

function PaymentCardSkeleton(): JSX.Element {
  const { t } = useTranslation([DomainEnum.ORDERS]);

  return (
    <Card title={t('draftOrders.paymentCard.title')}>
      <Text.Skeleton />
    </Card>
  );
}

export default PaymentCardSkeleton;
